module.exports = __webpack_public_path__ + "static/media/logo@2x.1b173a4b.png";